export function Footer() {
  return (
    <footer className="bg-[#083463] text-white py-6 text-center">
      <p className="mb-2">rfgmusicaespacio@gmail.com | +34 616 077 104</p>
      <div className="flex justify-center gap-4 text-sm">
        <a href="/privacidad" className="hover:underline">
          Política de Privacidad
        </a>
      </div>
      <small className="block mt-4">© {new Date().getFullYear()} Ricardo Fernández</small>
    </footer>
  );
}
